import { render, staticRenderFns } from "./Busca.vue?vue&type=template&id=07567333"
import script from "./Busca.vue?vue&type=script&lang=js"
export * from "./Busca.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports